module.exports = __webpack_public_path__ + "img/elex-logbox.de68051.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/medi-mass/elex-logbox.jpg
// module id = 612
// module chunks = 5